import Image from 'next/image';
import { byAppVariant } from '@/consts/AppVariants';
import emptyStateImageChristmas from '@/public/assets/image/global-states/empty/christmas/empty-christmas-state.webp';
import emptyStateImageSmall from '@/public/assets/image/global-states/empty/default/empty-default-state-small@3x.webp';
import emptyStateImageDefault from '@/public/assets/image/global-states/empty/default/empty-default-state@3x.webp';
import { cn } from '@/utils/cn';

type EmptyStateVisualProps = {
  className?: string;
  isCompactSize?: boolean;
  alt?: string;
};

const DEFAULT_IMAGE = byAppVariant({ christmas: emptyStateImageChristmas, default: emptyStateImageDefault });
const SMALL_IMAGE = byAppVariant({ christmas: emptyStateImageChristmas, default: emptyStateImageSmall });

const EmptyStateVisual = ({
  className,
  isCompactSize = false,
  alt = '',
}: EmptyStateVisualProps) => (
  <div className={cn('relative', className)}>
    <div
      className={cn(
        'absolute left-11.25 rounded-full blur-[1.71875rem] pointer-events-none bg-main-back-gradient',
        isCompactSize ? 'top-8 size-15.25' : 'top-7.75 size-25.75',
      )}
    />
    <Image
      src={isCompactSize ? SMALL_IMAGE : DEFAULT_IMAGE}
      alt={alt}
      className={cn('h-auto relative z-10 block', isCompactSize ? 'w-38' : 'w-50.5')}
      width={606}
      height={511}
    />
  </div>
);

export default EmptyStateVisual;
